import React from "react";
//import AccountPendingScreen from "../AuthenticationInner/LockScreen/AccountPendingScreen";
import StatsCards from "../DashboardAnalytics/StatsCards";
import SmsLog from "../SmsLogs";
import PlanUsageDashboardCard from "../PlanUsage/PlanUsageDashboardCard";
//import { useSelector } from "react-redux";
//import getConnectionStatus from "../../helpers/getConnectionStatus";

const UserDashboard = () => {
  // const { state } = useSelector((state) => ({
  //   state: state.Profile.user?.company?.state,
  // }));

  //const connectionStatus = state ? state : getConnectionStatus();

  return (
    <>
      {/* {connectionStatus === "Connection Complete" ? (
        <>
          <StatsCards />
          <SmsLog />
        </>
      ) : (
        <AccountPendingScreen />
      )} */}

      <PlanUsageDashboardCard />
      <StatsCards />
      <SmsLog />
    </>
  );
};

export default UserDashboard;
